export default function (value) {
  switch (value) {
    case 'EUR':
      return '€'
    case 'CHF':
      return 'CHF'
    case 'GBP':
      return '£'
    case 'USD':
      return '$'
    default:
      return value
  }
}
